import { useCallback } from 'react';

import {
  useTableState,
  useTableDispatch,
} from '../context/TableSchemaBuilderContext';
import { getSelectionRange } from '../utils/selectionHelpers';
import { useCellRefs } from './useCellRefs';

export const useTableSelection = () => {
  const { ui } = useTableState();
  const dispatch = useTableDispatch();
  const { cellRefs } = useCellRefs();

  const handleMouseDown = useCallback(
    (cellId) => {
      dispatch({ type: 'START_SELECTION', cellId });
      dispatch({ type: 'SET_EDIT_MODE', payload: true });

      const el = cellRefs?.current?.[cellId];
      if (el) {
        el.focus();
        // Position cursor at end of text for better UX when editing
        const val = el.value ?? '';
        if (typeof el.setSelectionRange === 'function') {
          const len = String(val).length;
          el.setSelectionRange(len, len);
        }
      }
    },
    [cellRefs, dispatch]
  );

  const handleMouseOver = useCallback(
    (cellId) => {
      if (ui?.isSelecting && ui?.anchorCell) {
        const selectedRange = getSelectionRange(ui?.anchorCell, cellId);
        dispatch({
          type: 'UPDATE_SELECTION',
          payload: {
            currentCell: cellId,
            cells: selectedRange,
          },
        });
      }
    },
    [ui?.isSelecting, ui?.anchorCell, dispatch]
  );

  const handleMouseUp = useCallback(() => {
    dispatch({ type: 'END_SELECTION' });
  }, [dispatch]);

  return {
    handleMouseDown,
    handleMouseOver,
    handleMouseUp,
  };
};
